import { render, staticRenderFns } from "./DataPerf.vue?vue&type=template&id=d365d73c&scoped=true"
import script from "./DataPerf.vue?vue&type=script&lang=js"
export * from "./DataPerf.vue?vue&type=script&lang=js"
import style0 from "./DataPerf.vue?vue&type=style&index=0&id=d365d73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d365d73c",
  null
  
)

export default component.exports